import type { Directive, DirectiveBinding } from 'vue'
import { hasAllPerm, hasAnyPerm } from '~/shared/utils/abilities'

interface CanDirectiveEl extends HTMLElement {
  __vCanPlaceholder?: Comment
  __vCanRemoved?: boolean
}

const canDirective: Directive<CanDirectiveEl, string | string[]> = {
    async mounted(el, binding) {

        let permissions = []
        let hasAccess = false
        
        if(typeof binding.value === 'string') {
            permissions = [binding.value]
        } else {
            permissions = binding.value
        }

        if(binding.modifiers.all) {
            hasAccess = await allows(hasAllPerm, permissions)
        } else {
            hasAccess = await allows(hasAnyPerm, permissions)
        }

        if(!hasAccess) {
            const placeholder = document.createComment('v-can')
            el.__vCanPlaceholder = placeholder
            el.__vCanRemoved = true
            el.parentNode?.replaceChild(placeholder, el)
        } else {
            el.__vCanRemoved = false
        }
    },

    async updated(el, binding) {

    }
}

export default canDirective